"use strict";

import Dropdown from './libs/dropdown';
import Categories from './libs/categories';
import Gallery from './libs/gallery';
import AjaxPagination from './libs/ajaxPagination';
import AjaxComments from './libs/ajaxComments';
import ResponsiveVids from './libs/ResponsiveVids';
import cookiesBanner from './libs/cookies-banner';

Dropdown('.js-nav-trigger','.js-nav-items');
Dropdown('.js-search-trigger','.js-search-box');
Categories();
AjaxPagination();
AjaxComments();
if(document.querySelector(".js-carousel")){ Gallery(); }
ResponsiveVids();
cookiesBanner();